var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatches = function SvgWatches(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.51C8 4.674 8.675 4 9.51 4h4.98c.835 0 1.51.675 1.51 1.51v.54c1.14.231 2 1.24 2 2.45v7c0 1.21-.86 2.219-2 2.45v.55a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 18.5v-.55c-1.14-.231-2-1.24-2-2.45v-7c0-1.21.86-2.219 2-2.45zm.5 1.99c-.553 0-1 .447-1 1v7c0 .553.447 1 1 1h7c.553 0 1-.447 1-1v-7c0-.553-.447-1-1-1zm4.25 2.25v1.9l1.231 1.025a.749.749 0 1 1-.96 1.153l-1.5-1.25a.75.75 0 0 1-.268-.575v-2.25c0-.415.335-.75.75-.75.416 0 .75.335.75.75z"
  })));
};
export default SvgWatches;